/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Formatconverterresults2Inputs */

const en_formatconverterresults2 = /** @type {(inputs: Formatconverterresults2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Results`)
};

const de_formatconverterresults2 = /** @type {(inputs: Formatconverterresults2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ergebnisse`)
};

/**
* | output |
* | --- |
* | "Results" |
*
* @param {Formatconverterresults2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const formatconverterresults2 = /** @type {((inputs?: Formatconverterresults2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Formatconverterresults2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_formatconverterresults2(inputs)
	return de_formatconverterresults2(inputs)
});
export { formatconverterresults2 as "formatConverterResults" }